<template>
  <div>
    <b-modal v-model="newPasswordModal" id="modal-1" title="Cambio de contraseña " hide-footer>
      <b-form>
        <b-alert v-if="newPasswordAlert" show variant="success">{{ newPasswordAlert }}</b-alert>
        <b-form-group label="reset_password" :invalid-feedback="invalidPasswordFeedback()" :valid-feedback="validPasswordFeedback(newPassword)" :state="validatePassword(newPassword)">
          <b-form-input v-model="newPassword" id="reset_password" placeholder="Nueva contraseña" :state="validatePassword(newPassword)" trim></b-form-input>
        </b-form-group>
        <b-button :disabled="!validatePassword(newPassword)" @click="resetPassword">reset</b-button>
      </b-form>
    </b-modal>

    <b-modal v-model="confirmEmailModal" id="modal-1" title="Confirmar usuario" hide-footer>
      <b-form>
        <b-alert v-if="confirmUserError" show variant="danger">{{ confirmUserError }}</b-alert>
        <b-alert v-if="confirmUserAlert" show variant="success">{{ confirmUserAlert }}</b-alert>
        <b-form-group label-for='email_confirm'>
          <b-form-input id="email_confirm" :placeholder="'Nombre de usuario'" v-model="usernameConfirm" trim></b-form-input>
        </b-form-group>
        <b-form-group label-for="confirmationCode">
          <b-form-input id="confirmationCode" :placeholder="'Codigo de verificacion'" v-model="confirmationCode" trim></b-form-input>
        </b-form-group>
        <b-button :disabled="!(usernameConfirm && confirmationCode.length == 6)" @click="userConfirmation">Confirmar</b-button>
      </b-form>
    </b-modal>

    <div class="signin">
      <b-container fluid>
        <b-row>
          <b-col md="12" class=" py-4 px-5" style="border-radius: 14px;">
            <h1 class="mb-5 text-center"><strong>Bienvenido de vuelta</strong></h1>
            <b-form>
                <b-alert v-if="errorMessage" dismissible show variant="danger">{{ errorMessage }}</b-alert>
                <b-form-group label="Correo electrónico" label-for="email" :invalid-feedback="invalidEmailFeedback()" :valid-feedback="validEmailFeedback(email)" :state="validateEmail(email)">
                  <b-form-input id="email" placeholder="Correo electrónico" v-model="email" :state="validateEmail(email)" trim class="input-lg"></b-form-input>
                </b-form-group>
                <b-form-group label="Contraseña" label-for="password" style="position: relative;" :invalid-feedback="invalidPasswordFeedback()" :valid-feedback="validPasswordFeedback(password)" :state="validatePassword(password)">
                  <b-form-input :type="!passwordHidden ? 'password':'text'" class="input-lg" id="password" placeholder="Contraseña" v-model="password" :state="validatePassword(password)" trim></b-form-input>
                  <span v-if="passwordHidden" class="display-eye fa fa-eye" @click="showPassword"></span>
                  <span v-if="!passwordHidden" class="display-eye fa fa-eye-slash" @click="hidePassword"></span>
                </b-form-group>
                <b-button type="button" variant="success" size="lg" class="float-right w-100 mt-4" style="height: 54px;" @click="signin">
                  <span v-if="loading" class="spinner-border spinner-border-sm mr-2" style="position: relative; top: -8px;" role="status" aria-hidden="true"></span>
                  Continuar
                </b-button>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import * as firebase from 'firebase/app'
import gql from 'graphql-tag'
const CREATE_SESSION = gql`
  mutation createSession($token: String, $app: String){
    createSession(session: {token: $token app: $app}){
      success
      message
    }
  }
`
export default {
  components: {
  },
  data() {
    return {
      email: '',
      password: '',
      error: false,
      loading: false,
      newPasswordModal: false,
      cognitoUser: null,
      confirmEmailModal: false,
      confirmationCode: '',
      usernameConfirm: '',
      newPassword: '',
      errorMessage: '',
      passwordHidden: '',
      newPasswordAlert: '',
      confirmUserAlert: '',
      confirmUserError: '',
    }
  },
  computed: {
    emailValidation() {
      return this.validEmail()
    },
  },
  beforeCreate() {
    // console.log(this.$cognito)
  },
  methods: {
    signin () {
      if (this.validateEmail(this.email) && this.validatePassword(this.password)) {
        this.loading = true
        this.$cognito.signin(this.email, this.password)
          .then(result => {
            const role = result.idToken.payload['custom:role_name']
            const jwt = result.accessToken.jwtToken
            console.log(role)
            this.$store.dispatch('user/LOAD_CURRENT_COGNITO_ACCOUNT', { payload: { email: this.email, role: role, jwt: jwt } })
            // firebase.firestore().collection('adminSession').doc(this.email).set({ user: this.email })
            this.$apollo.mutate({
              mutation: CREATE_SESSION,
              variables: {
                token: jwt,
                app: 'ADMIN',
              },
            })
              .then(data => {
                console.log(data)
                setTimeout(() => {
                  firebase.firestore().collection('adminSession').doc(this.email).onSnapshot(document => {
                    // console.log(document.data())
                    if (document.data() === undefined) {
                      // console.log('removed')
                      this.$cognito.signout()
                      this.$store.dispatch('user/LOGOUT_COGNITO')
                    }
                  })
                }, 1000)
                var url = this.$route.query.redirect
                this.loading = false
                if (url) {
                  this.$router.replace('/')
                } else {
                  this.$router.replace('/')
                }
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(err => {
            console.log(err)
            switch (err.message) {
              case 'Incorrect username or password.':
                this.errorMessage = 'El correo electrónico o contraseña son incorrectos. Vuelve a intentarlo'// err.message
                break
              case 'User is disabled.':
                this.errorMessage = 'El usuario está deshabilitado'
                break
              default:
                this.errorMessage = 'Error'
            }
            this.loading = false
          })
      }
    },
    invalidEmailFeedback() {
      return this.$t('El correo electrónico no es válido. Vuelve a intentarlo.')
    },
    validEmailFeedback(email) {
      return this.validateEmail(email) === true ? 'El correo electrónico es válido.' : 'El correo electrónico no es válido. Vuelve a intentarlo.'
    },
    validateEmail(email) {
      var re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
      return email ? re.test(email) : null
    },
    validatePassword(password) {
      var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/
      return password ? re.test(password) : null
    },
    validPasswordFeedback(password) {
      return this.validatePassword(password) === true ? 'La contraseña es válida' : 'Inválido'
    },
    invalidPasswordFeedback() {
      return this.$t('La contraseña no es válida. Vuelve a intentarlo')
    },
    resetPassword() {
      this.cognitoUser.completeNewPasswordChallenge(this.newPassword, null, {
        onSuccess: (result) => {
          this.newPasswordAlert = 'Cambio de contraseña realizado'
          setTimeout(() => {
            this.newPasswordModal = false
            this.newPasswordAlert = ''
          }, 1500)
        },
        onFailure: (err) => {
          console.log('Error')
          console.log(err)
        },
      })
    },
    hidePassword() {
      this.passwordHidden = true
    },
    showPassword() {
      this.passwordHidden = false
    },
    userConfirmation() {
      /*
      this.$cognito.confirmation(this.usernameConfirm, this.confirmationCode)
        .then(result => {
          this.confirmUserAlert = 'Usuario confirmado'
          setTimeout(() => {
            this.confirmEmailModal = false
            this.confirmUserAlert = ''
          }, 1000)
        })
        .catch(error => {
          switch (error.code) {
            case 'CodeMismatchException':
              this.confirmUserError = error.message
              setTimeout(() => {
                this.confirmUserError = ''
              }, 3000)
              break
            default:
              this.confirmUserError = 'Error'
              setTimeout(() => {
                this.confirmUserError = ''
              }, 3000)
          }
        })
        */
    },
  },
}
</script>
<style lang="scss">
  .space {
    height: 10px;
  }
  .display-eye {
    cursor:pointer;
  }
  .signin {
    h3 {
      margin-bottom: 30px;
    }
    .forget-password {
      margin-top: 20px;
      font-size: 15px;
    }
  }
</style>
